import { registerBlockType } from '@wordpress/blocks';
import './style.scss';
import './editor.scss';
import Edit from './edit';
import save from './save';
import metadata from './block.json';
import indexjson from './edit.json';
import advancejson from '@vayu-blocks/advance-panel/advance.json';

const faqsvg = (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" context="list-view" aria-hidden="true" focusable="false"><path d="M12.0067 10.2C12.34 9.6 13.0067 9 14.0067 9C15.0067 9 16.0067 9.9 16.0067 10.8C16.0067 11.6628 15.394 12.2498 14.7527 12.5118C14.6977 12.5343 14.6397 12.5477 14.5824 12.5632C14.2608 12.6496 14.0067 12.8957 14.0067 13.2M14.0067 15H14.0133M11.0002 15H11.0069M8.00017 15H8.00684M21.0001 12C21.0001 16.9706 16.9706 21 12.0001 21C10.5124 21 9.1091 20.6391 7.87286 20C7.19356 19.6488 3.56466 21.5054 3 21C2.43678 20.4959 4.93748 17.6302 4.51561 17C3.55833 15.5699 3.00006 13.8501 3.00006 12C3.00006 7.02944 7.0295 3 12.0001 3C16.9706 3 21.0001 7.02944 21.0001 12Z" fill="none" stroke="#6c1bc3" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"></path></svg>
);

registerBlockType( metadata.name, {
	...metadata,
	attributes: {...indexjson, ...advancejson},
	edit: Edit,
	icon: faqsvg,
	save,
});